import type { RefObject } from 'react';

interface FieldsProps {
  enabled: boolean;
  value: number;
  disabled: boolean;
  saveDisabled: boolean;
  onEnabled: (value: boolean) => void;
  onValue: (value: number) => void;
  onSave: () => void;
  saveRef: RefObject<HTMLButtonElement | null>;
}

const box =
  'rounded-control border-line focus-within:outline-forest flex min-h-[52px] min-w-0 flex-col justify-center border px-3 py-1.5 focus-within:outline focus-within:outline-2';

/** Aufschlag eines Kanals: „Aus“ oder „Prozentual erhöhen“ mit Prozent, dann speichern. */
export function ChannelModifierFields(props: FieldsProps) {
  return (
    <>
      <div className="grid grid-cols-[1.3fr_1fr] gap-2">
        <label className={box}>
          <span className="text-ink-soft text-[11px]">Kanalaufschlag</span>
          <select
            aria-label="Kanalaufschlag"
            className="w-full bg-transparent text-sm font-bold outline-none"
            value={props.enabled ? 'on' : 'off'}
            disabled={props.disabled}
            onChange={(event) => props.onEnabled(event.target.value === 'on')}
          >
            <option value="off">Aus</option>
            <option value="on">Prozentual erhöhen</option>
          </select>
        </label>
        <label className={box}>
          <span className="text-ink-soft text-[11px]">Aufschlag in %</span>
          <input
            aria-label="Aufschlag in %"
            className="w-full min-w-0 bg-transparent text-sm font-bold outline-none disabled:opacity-50"
            type="number"
            inputMode="decimal"
            min="0.01"
            max="100"
            step="0.01"
            value={props.value}
            disabled={!props.enabled || props.disabled}
            onChange={(event) => props.onValue(Number(event.target.value))}
          />
        </label>
      </div>
      <button
        ref={props.saveRef}
        type="button"
        disabled={props.saveDisabled}
        onClick={props.onSave}
        className="rounded-pill bg-ink min-h-11 self-start px-4 text-[13px] font-bold text-white disabled:opacity-40"
      >
        Kanalpreis speichern
      </button>
    </>
  );
}
